import { userPermissionsSelector } from "@/libs/auth";
import { NotificationRegistryRead } from "@/services/generatedApi";
import { useAppSelector } from "@/services/store";
import { NotificationBody } from "@/ui-components/components/UserMenu/components/NotificationBody";
import { buildNotificationLink } from "@/ui-components/components/UserMenu/components/utils";
import { Box, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

type NotificationsListBodyProps = {
  notifications: NotificationRegistryRead[];
  header: string;
  markAsRead: (id: number) => void;
};

export const NotificationsListBody: React.FC<NotificationsListBodyProps> = ({ notifications, header, markAsRead }) => {
  const { t } = useTranslation();
  const groups = useAppSelector(userPermissionsSelector);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          padding: "13px 24px 14px 16px",
        }}
      >
        <Typography
          sx={{
            color: "#7E7E7E",
            textTransform: "uppercase",
            fontWeight: "800",
            fontSize: "14px",
          }}
        >
          {header}
        </Typography>
      </Box>
      {notifications.map(notification => (
        <NotificationBody
          notification={notification}
          key={notification.id}
          markAsRead={markAsRead}
          link={buildNotificationLink(notification, groups)}
        />
      ))}
    </>
  );
};
